import omitBy from 'lodash-es/omitBy';

export const removeEmptyString = (values: object) => {
  return omitBy(values, v => v === '');
};
